
export const ColorUtil = {

    stringToRGB: (text: string) => {
        let hash = 0;
        
        // Generating a unique number based on the text using a hash function
        for (let i = 0; i < text.length; i++) {
            hash = text.charCodeAt(i) + ((hash << 5) - hash);
        }
    
        // Function to get an RGB value from the hash
        const getComponent = (x) => {
            return ((hash >> x) & 0xFF);
        };
    
        // Calculate red, green, and blue values from the hash
        const red = getComponent(0);
        const green = getComponent(8);
        const blue = getComponent(16);
    
        return `rgb(${ColorUtil.suavizarColorRGB(red)}, ${ColorUtil.suavizarColorRGB(green)}, ${ColorUtil.suavizarColorRGB(blue)})`;
    },

    suavizarColorRGB: (color, factor = 0.3) => {
        // Verificar que el factor esté entre 0 y 1
        if (factor < 0) factor = 0;
        if (factor > 1) factor = 1;

        return (color * (1 - factor) + 255 * factor);
    }
    
}